import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    HasProduct,
    HasProductContext,
    withProduct,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getDiscontinuedStatus } from "@preferredMedical/Store/Data/Products/ProductsSelectors";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, productContext: HasProductContext) => ({
    discontinuedStatus: getDiscontinuedStatus(state, productContext.productContext.product.id),
    isLoggedIn: (state.context.session.isAuthenticated || state.context.session.rememberMe) && !state.context.session.isGuest,
});

type Props = HasProductContext & ReturnType<typeof mapStateToProps>;

export interface ProductDiscontinuedStatusStyles {
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    errorTextTitle?: TypographyPresentationProps;
}

export const styles: ProductDiscontinuedStatusStyles = {
    errorText: { weight: "normal" },
    errorTextTitle: {
        weight: "bold",
        css: css`
            margin-right: 10px;
        `,
    },
};

const ProductDiscontinuedStatus = ({ discontinuedStatus, productContext, isLoggedIn }: Props) => {

    if (!discontinuedStatus || discontinuedStatus === null || productContext.product.isVariantParent || !isLoggedIn) {
        return null;
    }

    return (
        <StyledWrapper {...styles.errorWrapper}>
            {discontinuedStatus === "discontinued" && (
                <>
                    <Typography {...styles.errorTextTitle}>{siteMessage("DiscontinuedHeading")}</Typography>
                    <Typography {...styles.errorText}>{siteMessage("ProductDiscontinuedMessagePDP")}</Typography>
                </>
            )}
            {discontinuedStatus === "to be discontinued" && (
                <>
                    <Typography {...styles.errorTextTitle}>{siteMessage("ToBeDiscontinuedHeading")}</Typography>
                    <Typography {...styles.errorText}>{siteMessage("ProductToBeDiscontinuedMessage")}</Typography>
                </>
            )}
            {discontinuedStatus === "part number change" && (
                <>
                    <Typography {...styles.errorTextTitle}>{siteMessage("PartNumberChangeHeading")}</Typography>
                    <Typography {...styles.errorText}>{siteMessage("ProductPartNumberChangeMessage")}</Typography>
                </>
            )}
            {discontinuedStatus === "temp not for sale" && (
                <>
                    <Typography {...styles.errorTextTitle}>{siteMessage("TempNotForSaleHeading")}</Typography>
                    <Typography {...styles.errorText}>{siteMessage("ProductTempNotForSaleMessage")}</Typography>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDiscontinuedStatus)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
